import ScheduleInventoryExportModal, { ScheduleInventoryExportModalStyles } from "@gemeco/CustomComponents/ScheduleInventoryExportModal";
import gemecoExportHandler from "@gemeco/Handlers/GemecoExportHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import React, { useContext, useEffect, useState } from "react";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import gemecoExportDetailsHandler from "@gemeco/Handlers/GemecoExportDetailsHandler";
import { GemecoExportDetailsState } from "@gemeco/Store/Reducer/GemecoExportDetailsReducer";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
interface OwnProps {
    isOpen: boolean;
    handleClose(): void;
    extendedStyles?: ScheduleInventoryExportModalStyles;
}

const mapDispatchToProps = {
    gemecoExportHandler,
    gemecoExportDetailsHandler,
};

const mapStateToProps = (state: GemecoExportDetailsState) => ({
    userName: state.context.session.userName,
    customerId: state.context.session.shipToId,
    exportDetails: state.GemecoExportDetailsReducer?.mainData,
    webUrl: state.context.session.uri,
});

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface InventoryDataExportStyles {
    inventoryButton?: ButtonPresentationProps;
    mainButtonWrapper?: TypographyProps;
    scheduleReminderModal?: ScheduleInventoryExportModalStyles;
}

export const inventoryDataExportStyles: InventoryDataExportStyles = {
    mainButtonWrapper: {
        css: css`
        display: flex;
        flex-direction: row;
        margin-bottom: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`flex-direction: column;`,
                    null,
                    null,
                    null,
                    null,
                ])}
        `
    },
    inventoryButton: {
        css: css`
            padding: 0 15px;
            margin-right: 20px;
            margin-bottom: 15px;
        `,
        variant: "primary",
    }
};

const styles = inventoryDataExportStyles;

const InventoryDataExport = ({
    history,
    userName,
    customerId,
    gemecoExportHandler,
    gemecoExportDetailsHandler,
    exportDetails,
    webUrl,
}: Props) => {
    if (!userName) {
        history.push("/SignIn");
    }
    const [isSubmitted, setIsSubmitted] = useState(false);
    const toasterContext = useContext(ToasterContext);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = React.useState(false);
    const exportDetailsDataMain: any = exportDetails;

    useEffect(() => {
        setIsSubmitted(false);
        gemecoExportDetailsHandler({
            customerID: `${customerId}`,
        })
    }, []);

    const scheduleButtonText = exportDetailsDataMain[0]?.frequency !== undefined ? translate("Edit Inventory File") : translate("Schedule Inventory File");

    const updatedUrl = webUrl.replace("/sessions/current", "");

    const onExportButtonHandler = () => {
        setIsSubmitted(true);
        gemecoExportHandler({
            customerID: `${customerId}`,
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    setIsSubmitted(false);
                    window.open(`${updatedUrl}/downloadexport?customerID=${customerId}`)
                }
            },
            onError: message => {
                setIsSubmitted(true);
                toasterContext.addToast({ body: message, messageType: "danger" });
            },
        })
    };

    const onResetPasswordClose = () => {
        setIsResetPasswordModalOpen(false);
    };

    const scheduleReminderClickHandler = () => {
        setIsResetPasswordModalOpen(true);
    }

    return (
        <StyledWrapper {...styles.mainButtonWrapper}>
            <LoadingOverlay loading={isSubmitted} spinnerProps={{ color: "primary" }}>
                <Button {...styles.inventoryButton} onClick={() => onExportButtonHandler()}>
                    {translate("Export Inventory File")}
                </Button>
                <Button {...styles.inventoryButton} onClick={() => scheduleReminderClickHandler()}>
                    {scheduleButtonText}
                </Button>
                <ScheduleInventoryExportModal
                    isOpen={isResetPasswordModalOpen}
                    handleClose={() => onResetPasswordClose()}
                    extendedStyles={styles.scheduleReminderModal} />
            </LoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(InventoryDataExport)),
    definition: {
        group: "Basic",
        displayName: "Inventory Data Export",
    },
};

export default widgetModule;

